<template>
  <div class="home">
    <!-- header -->
    <Header />
    <!-- end header -->
    <!-- section 1 -->
    <section>
      <div class="top-section">
        <div>
          <h1>Your Healthcare Destination</h1>
          <h2>A Secure and Confidential health care portal on your fingertips.</h2>
          <!-- <button class="btn demo-btn">View Demo</button> -->
          <!-- <b-img-lazy src="/images/19834.jpg" /> -->
          <img src="/images/homeBanner.webp" alt="Banner" />
        </div>
      </div>
    </section>
    <!-- end section 1 -->
    <!-- section 2 -->
    <section>
      <div class="con">
        <div class="home-centers">
          <router-link :to="{ name: 'search.doctor' }">
            <div>
              <doctor></doctor>
              <p>Doctor</p>
            </div>
          </router-link>
          <a @click="openForm('Ambulance')">
            <div title="Click for services">
              <ambulance></ambulance>
              <p>Ambulance</p>
            </div>
          </a>
          <!-- <a @click="openForm('Hospital')">
            <div title="Click for services">
              <hospital></hospital>
              <p>Hospital</p>
            </div>
          </a> -->
          <a @click="hospitalSearch()">
            <div title="Click for services">
              <hospital></hospital>
              <p>Hospital</p>
            </div>
          </a>
          <a @click="openForm('Diagnostic')">
            <div title="Click for services">
              <medicalRecord></medicalRecord>
              <p>Diagnostic</p>
            </div>
          </a>
          <a @click="openForm('Pharmacy')">
            <div title="Click for services">
              <prescription></prescription>
              <p>Pharmacy</p>
            </div>
          </a>
          <a @click="openForm('Blood Bank')">
            <div title="Click for services">
              <blood></blood>
              <p>Blood Bank</p>
            </div>
          </a>
          <a @click="openForm('Click for services')">
            <div title="Click for services">
              <customerService></customerService>
              <p>Sales & Services</p>
            </div>
          </a>
        </div>
      </div>
    </section>
    <!-- end section 2 -->
    <!-- about us -->
    <section>
      <div class="home-about">
        <div class="w-50 abt-back">
          <!-- <b-img-lazy src="/images/mac.png" alt /> -->
          <img src="/images/mac.webp" alt="Mac" />
        </div>
        <div class="w-50 con-3">
          <div>
            <h1>About Us</h1>
            <p class="p-info">
              Many Software’s exist in the market. But they all work in
              isolation and cater to only a part of the health care eco-system.
            </p>
            <p class="p-info">
              DOCSMART is a novel health care software which addresses this
              lacunae and helps in linking all health care services under a
              Common cloud based Health care Ecosystem (HES).
            </p>
            <p class="p-info">
              Various Modules for health care Providers are created which talk
              among themselves in real time without any external interference,
              maintaining a secure and confidential environment.
            </p>
            <p class="p-info">
              Unlike many existing software’s the Search Module for Providers is
              offered free so that genuine information is shared with the
              patients. The App allows for genuine Rating and Reviews along with
              features towards online Chat and Grievance redressal among others.
              All modules for the Providers are comprehensively made to include
              Appointments, Staff, Stock and Accounting features among others.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- end about us -->
    <!-- services -->
    <section>
      <div class="home-services text-center">
        <div class="ww-100">
          <h1>Services</h1>
          <h2>
            DocSmart Offers a gamut of services. A platform for all stake
            holders to interact among themselves.
          </h2>
          <div class="con">
            <div class="service-left ww-100">
              <!-- <span
                hidden
                @click="serviceTab = 'service'"
                :class="{ active: serviceTab == 'service' }"
              ></span>-->
              <div
                class="service-list text-center"
                @click="(serviceTab = 'doctor'), showCurrent()"
                :class="{ active: serviceTab == 'doctor' }"
              >
                <div>
                  <doctor></doctor>
                </div>
                <p>Doctors</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'patient'), showCurrent()"
                :class="{ active: serviceTab == 'patient' }"
              >
                <div>
                  <patient></patient>
                </div>
                <p>Patient</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'ambulance'), showCurrent()"
                :class="{ active: serviceTab == 'ambulance' }"
              >
                <div>
                  <ambulance></ambulance>
                </div>
                <p>Ambulance</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'blood'), showCurrent()"
                :class="{ active: serviceTab == 'blood' }"
              >
                <div>
                  <blood></blood>
                </div>
                <p>Blood Bank</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'hospital'), showCurrent()"
                :class="{ active: serviceTab == 'hospital' }"
              >
                <div>
                  <hospital></hospital>
                </div>
                <p>Hospital</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'prescription'), showCurrent()"
                :class="{ active: serviceTab == 'prescription' }"
              >
                <div>
                  <prescription></prescription>
                </div>
                <p>Pharmacy</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'medicalRecord'), showCurrent()"
                :class="{ active: serviceTab == 'medicalRecord' }"
              >
                <div>
                  <medicalRecord></medicalRecord>
                </div>
                <p>Diagnostic</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'chat'), showCurrent()"
                :class="{ active: serviceTab == 'chat' }"
              >
                <div>
                  <chat></chat>
                </div>
                <p>Chat</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'seller'), showCurrent()"
                :class="{ active: serviceTab == 'seller' }"
              >
                <div>
                  <seller></seller>
                </div>
                <p>Vendor</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'stockist'), showCurrent()"
                :class="{ active: serviceTab == 'stockist' }"
              >
                <div>
                  <stockist></stockist>
                </div>
                <p>Pharma / Stockist</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'insurance'), showCurrent()"
                :class="{ active: serviceTab == 'insurance' }"
              >
                <div>
                  <insurance></insurance>
                </div>
                <p>Insurance</p>
              </div>
              <div
                class="service-list text-center"
                @click="(serviceTab = 'court'), showCurrent()"
                :class="{ active: serviceTab == 'court' }"
              >
                <div>
                  <court></court>
                </div>
                <p>Government</p>
              </div>
            </div>
            <div class="service-right-main ww-100" id="docsmartServices">
              <div class="service-right">
                <!-- <div class="service-icon">
                  <div>
                    <service v-if="serviceTab == 'service'"></service>
                    <doctor v-if="serviceTab == 'doctor'"></doctor>
                    <patient v-if="serviceTab == 'patient'"></patient>
                    <ambulance v-if="serviceTab == 'ambulance'"></ambulance>
                    <blood v-if="serviceTab == 'blood'"></blood>
                    <hospital v-if="serviceTab == 'hospital'"></hospital>
                    <prescription v-if="serviceTab == 'prescription'"></prescription>
                    <medicalRecord v-if="serviceTab == 'medicalRecord'"></medicalRecord>
                    <chat v-if="serviceTab == 'chat'"></chat>
                    <seller v-if="serviceTab == 'seller'"></seller>
                    <stockist v-if="serviceTab == 'stockist'"></stockist>
                    <insurance v-if="serviceTab == 'insurance'"></insurance>
                    <court v-if="serviceTab == 'court'"></court>
                  </div>
                </div>-->
                <div class="service-info">
                  <!-- service -->
                  <!-- <div v-if="serviceTab == 'service'">
                    <div class="top-div">
                      <service></service>
                      <h4>About Services</h4>
                    </div>
                    <p class="p-info text-left">
                      Lorem Ipsum is simply dummy five centuries, but also the
                      leap into electronic typesetting, remaining essentially
                      unchanged. It was popularised in the 1960s with the
                      release of Letraset sheets containing Lorem Ipsum
                      passages, and more recently with desktop publishing
                      software like Aldus PageMaker including versions of Lorem
                      Ipsum.
                    </p>
                  </div>-->
                  <!-- end service -->
                  <!-- doctor -->
                  <div v-if="serviceTab == 'doctor'">
                    <div class="top-div">
                      <doctor></doctor>
                      <h4>Doctor</h4>
                    </div>
                    <p class="p-info text-left">
                      All the needs of a doctor in the form of Visibility,
                      Appointment Booking, Out Patient Module, In Patient online
                      Hospital records Access, Online Consultation,
                      Telemedicine, Conferences, Online Meetings, Webinars,
                      News-Blogs-Forums and Emergency Codes form part of this
                      software. The doctor can access health records in real
                      time.
                    </p>
                  </div>
                  <!-- end doctor -->
                  <!-- patient -->
                  <div v-if="serviceTab == 'patient'">
                    <div class="top-div">
                      <patient></patient>
                      <h4>patient</h4>
                    </div>
                    <p class="p-info text-left">
                      The Patients have access in real time to their Medical
                      Records, Appointments, Reports, Certificates, Online
                      Consultation, Second Opinion and Grievance Redressal. The
                      App offers ease of Searching for Doctors, Ambulance,
                      Hospitals, Pharmacy, Diagnostic centres, Blood Banks,
                      Vendors and Services. The App informs Cost towards
                      services and Disease information in real time. The Privacy
                      and security of data is maintained at all times.
                    </p>
                  </div>
                  <!-- end patient -->
                  <!-- ambulance -->
                  <div v-if="serviceTab == 'ambulance'">
                    <div class="top-div">
                      <ambulance></ambulance>
                      <h4>ambulance</h4>
                    </div>
                    <p class="p-info text-left">
                      Emergency as well as routine Ambulance can be booked on
                      line with ease. The category of Ambulance, their
                      availability, Staff allocation, and real time Location of
                      ambulance can be seen by the Ambulance centre. The Driver
                      mobile app completes the trip with costing. The App can
                      help during a Disaster with timely allocation of Ambulance
                      and Hospital Beds.
                    </p>
                  </div>
                  <!-- end ambulance -->
                  <!-- blood -->
                  <div v-if="serviceTab == 'blood'">
                    <div class="top-div">
                      <blood></blood>
                      <h4>bloodbank</h4>
                    </div>
                    <p class="p-info text-left">
                      Online Emergency booking and Reservation of blood is
                      possible by the App. Availability of blood, Issuing of
                      Blood, Blood Donation , Online Camp Organizer, Staff
                      allocation, Testing of blood and Technician module is
                      provided. Delivery of blood to hospitals can be followed
                      in real time. This prevents wastage of Blood.
                    </p>
                  </div>
                  <!-- end blood -->
                  <!-- hospital -->
                  <div v-if="serviceTab == 'hospital'">
                    <div class="top-div">
                      <hospital></hospital>
                      <h4>hospital</h4>
                    </div>
                    <p class="p-info text-left">
                      Hospitals get Online Reach to Patients, Doctors and
                      Insurance. Online Searchable variants are incorporated
                      such as: Services offered, Panel of Doctors, Health and
                      Disease packages and Emergency Facility available.
                      Hospitals have been given Polyclinic and IPD software
                      which includes Staff, Stock and accounting modules. The
                      Software has presence of various Emergency Codes and
                      Protocols and Crowd Management System in place.
                    </p>
                  </div>
                  <!-- end hospital-->
                  <!-- prescription -->
                  <div v-if="serviceTab == 'prescription'">
                    <div class="top-div">
                      <prescription></prescription>
                      <h4>Prescription</h4>
                    </div>
                    <p class="p-info text-left">
                      DocSmart offers Online reach to Patients and E
                      prescription connect. It incorporates a Pharmacy software
                      having both generic and brand names of medicines. It has
                      Provision for Online Purchase from stockists and Auto
                      update of medicines data. It has provision for Home
                      delivery of medicine.
                    </p>
                  </div>
                  <!-- end prescription -->
                  <!-- medicalRecord -->
                  <div v-if="serviceTab == 'medicalRecord'">
                    <div class="top-div">
                      <medicalRecord></medicalRecord>
                      <h4>Diagnostic</h4>
                    </div>
                    <p class="p-info text-left">
                      Diagnostic centres are seen in search and E booking of
                      Tests and Health packages can be done directly by the
                      patients or Doctors. Online reports are shared with
                      Patients and Doctors. Provision for Critical value
                      reporting. Technician module for Collection, Testing and
                      Home Visit. Provision for Insurance and company health
                      check for patients.
                    </p>
                  </div>
                  <!-- end medicalRecord -->
                  <!-- chat -->
                  <div v-if="serviceTab == 'chat'">
                    <div class="top-div">
                      <chat></chat>
                      <h4>chat</h4>
                    </div>
                    <p class="p-info text-left">
                      All modules are integrated with connect/ contact feature.
                      This allows Calling, Video Calling, Conference call, Intra
                      App Messaging and Intra Centre Chat. The Chat module can
                      synchronise your phone contacts for the above features.
                      System groups allow grouping of people/ specialists.
                    </p>
                  </div>
                  <!-- end chat -->
                  <!-- seller -->
                  <div v-if="serviceTab == 'seller'">
                    <div class="top-div">
                      <seller></seller>
                      <h4>Vendor</h4>
                    </div>
                    <p class="p-info text-left">
                      Vendors can reach out to target clients to sell their
                      products online. Products can be listed as per Company,
                      Products, Costings and other parameters. Online Payment
                      and Bulk Selling is possible. Both free and Paid version
                      to reach to target client is available. There is provision
                      towards Tracking of Delivery both by Vendors and Clients.
                    </p>
                  </div>
                  <!-- end seller-->
                  <!-- stockist -->
                  <div v-if="serviceTab == 'stockist'">
                    <div class="top-div">
                      <stockist></stockist>
                      <h4>pharmacy</h4>
                    </div>
                    <p class="p-info text-left">
                      Pharma companies can reach out to doctors via the IMR
                      system. New products, existing products information,
                      events propagation can be done digitally to the target
                      speciality. Reach to stockists and retailers for online
                      purchase is possible.
                    </p>
                  </div>
                  <!-- end stockist -->
                  <!-- insurance -->
                  <div v-if="serviceTab == 'insurance'">
                    <div class="top-div">
                      <insurance></insurance>
                      <h4>Insurance</h4>
                    </div>
                    <p class="p-info text-left">
                      The insurance sector gets information in real time about
                      their insured when they avail Admission as well as Out
                      patient Services. Companies can check the status of
                      admission in real time. Its unique feature allows digital
                      transferring of files and bills with filtering of
                      non-payables.
                    </p>
                  </div>
                  <!-- end insurance -->
                  <!-- court -->
                  <div v-if="serviceTab == 'court'">
                    <div class="top-div">
                      <court></court>
                      <h4>Government</h4>
                    </div>
                    <p class="p-info text-left">
                      The Government can see in real time the demography of
                      disease prevalence and efficacy of various Government
                      programs towards its redressal. Through the system, the
                      Government can plan various strategies and evaluate its
                      efficacy. They can reach out to various health stake
                      holders and citizens to notify them or propagate its
                      various schemes.
                    </p>
                  </div>
                  <!-- end court -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- end services -->
    <!-- coming soon -->
    <section>
      <div class="coming-soon-main-top">
        <div class="con">
          <div class="div-left w-50">
            <h1>Coming Soon</h1>
            <p class="p-info">
              Every version will surprise you with its new features. So keep
              abreast as DocSmart unfolds itself over the next 6 to 8 months.
              New versions will be added and present one upgraded with time.
            </p>
            <!-- <p
              class="p-info"
            >magni aspernatur fugiat quo voluptatum illum necessitatibus vel rem nemo, odit iure magnam</p>-->
            <div class="notifyMe">
              <div>
                <input
                  v-model="notifyEmail"
                  name="notify email"
                  id="notifyEmail"
                  v-validate="'email'"
                  type="text"
                  class="form-control"
                  placeholder="Enter Your Email"
                  autocomplete="off"
                />
              </div>
              <button @click="getNotify()" class="btn btn-grn-dolid" :disabled="!notifyEmail">
                Notify me
                <span>&#10230;</span>
              </button>
            </div>
            <span class="text-danger">{{ errors.first("notify email") }}</span>
          </div>
          <div class="div-right w-50">
            <div class="product-top">
              <div class="div-left-prod">
                <div class="div1">
                  <div class="inner-div">
                    <div class="svg-div">
                      <packageSVG />
                    </div>
                    <p>Products</p>
                    <p>
                      DocSmart will be a one stop destination for all your
                      Medical Product needs, be it small or major equipment’s.
                    </p>
                  </div>
                  <div class="back-div">
                    <packageSVG />
                  </div>
                </div>
                <div class="div2">
                  <div class="inner-div">
                    <div class="svg-div">
                      <party />
                    </div>
                    <p>Events</p>
                    <p>
                      Medical Events and Camps can be planned and propagated
                      among target members. Members can search for upcoming
                      events of their interest.
                    </p>
                  </div>
                  <div class="back-div">
                    <party />
                  </div>
                </div>
              </div>
              <div class="div-right-prod">
                <div class="div3">
                  <div class="inner-div">
                    <div class="svg-div">
                      <interview />
                    </div>
                    <p>News</p>
                    <p>
                      Medical News, Blogs, Pages will allow interaction in the
                      app among its various members.
                    </p>
                  </div>
                  <div class="back-div">
                    <interview />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- end coming soon -->
    <!-- events -->
    <!-- <section>
      <div class="home-event text-center">
        <div>
          <h1>Events</h1>
          <h3>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </h3>
          <div class="con">
    card-->
    <!-- <div class="card">
              <div class="card-header">
                <div class="date">12</div>
                <div class="day">
                  <p>Saturday 5.30 pm</p>
                  <p>December - 2019</p>
                </div>
              </div>
              <b-img-lazy src="/images/event1.jpeg" alt />
              <div class="card-body cont text-left">
                <h4>Lorem Ipsum</h4>
                <div class="mb-1">
                  <user></user>
                  <span>Created by- Lorem Ipsum</span>
                </div>
                <div class="mb-1">
                  <location></location>
                  <span>Andheri east, mumbai</span>
                </div>
                <div class="mb-1">
                  <ticket></ticket>
                  <span>&#8377; 123</span>
                </div>
                <div>
                  <button class="btn">
                    <likehrt></likehrt>Mark Intrested
                  </button>
                </div>
              </div>
            </div>
    end card-->
    <!-- card -->
    <!--   <div class="card">
              <div class="card-header">
                <div class="date">12</div>
                <div class="day">
                  <p>Saturday 5.30 pm</p>
                  <p>December - 2019</p>
                </div>
              </div>
              <b-img-lazy src="/images/event2.jpeg" alt />
              <div class="card-body cont text-left">
                <h4>Lorem Ipsum</h4>
                <div class="mb-1">
                  <user></user>
                  <span>Created by- Lorem Ipsum</span>
                </div>
                <div class="mb-1">
                  <location></location>
                  <span>Andheri east, mumbai</span>
                </div>
                <div class="mb-1">
                  <ticket></ticket>
                  <span>&#8377; 123</span>
                </div>
                <div>
                  <button class="btn">
                    <likehrt></likehrt>Mark Intrested
                  </button>
                </div>
              </div>
            </div>
    end card-->
    <!-- card -->
    <!-- <div class="card">
              <div class="card-header">
                <div class="date">12</div>
                <div class="day">
                  <p>Saturday 5.30 pm</p>
                  <p>December - 2019</p>
                </div>
              </div>
              <b-img-lazy src="/images/event3.jpeg" alt />
              <div class="card-body cont text-left">
                <h4>Lorem Ipsum</h4>
                <div class="mb-1">
                  <user></user>
                  <span>Created by- Lorem Ipsum</span>
                </div>
                <div class="mb-1">
                  <location></location>
                  <span>Andheri east, mumbai</span>
                </div>
                <div class="mb-1">
                  <ticket></ticket>
                  <span>&#8377; 123</span>
                </div>
                <div>
                  <button class="btn">
                    <likehrt></likehrt>Mark Intrested
                  </button>
                </div>
              </div>
            </div>
    end card-->
    <!-- </div>
          <div class="view-all">
            <p>View All</p>
          </div>
        </div>
      </div>
    </section>-->
    <!-- end events -->
    <!-- news -->
    <!-- <section>
      <div class="home-news text-center">
        <div>
          <h1>News</h1>
          <h3>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </h3>
          <div class="news-main con">
            <div class="w-50 text-left">
              <div class="left-news">
                <b-img-lazy src="/images/news4.jpeg" alt class="image-responsive mb-3" />
                <h4>
                  <b>Lorem Ipsum</b>
                </h4>
                <p>18 December - 2020</p>
                <p class="p-info">
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen book.
                </p>
              </div>
            </div>
            <div class="w-50 text-left news-l">
    -->
    <!-- <div class="right-news mb-4">
                <b-img-lazy src="/images/news1.jpeg" alt />
                <div>
                  <h4>
                    <b>Lorem Ipsum</b>
                  </h4>
                  <p>18 December - 2020</p>
                  <p class="p-info">
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled it to make a type specimen book.
                  </p>
                </div>
    </div>-->
    <!-- -->
    <!-- <div class="right-news mb-4">
                <b-img-lazy src="/images/news2.jpeg" alt />
                <div>
                  <h4>
                    <b>Lorem Ipsum</b>
                  </h4>
                  <p>18 December - 2020</p>
                  <p class="p-info">
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled it to make a type specimen book.
                  </p>
                </div>
    </div>-->
    <!-- -->
    <!-- <div class="right-news mb-4">
                <b-img-lazy src="/images/news3.jpeg" alt />
                <div>
                  <h4>
                    <b>Lorem Ipsum</b>
                  </h4>
                  <p>18 December - 2020</p>
                  <p class="p-info">
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled it to make a type specimen book.
                  </p>
                </div>
    </div>-->
    <!-- -->
    <!-- </div>
          </div>
          <div class="con view-all text-right">
            <p>View All</p>
          </div>
        </div>
      </div>
    </section>-->
    <!-- end news -->
    <!-- product -->
    <!-- <section>
      <div class="home-product text-center">
        <div>
          <h1>Products Offered</h1>
          <h3>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </h3>
          <div class="con">
    card-->
    <!-- <div class="card">
              <div class="img-div">
                <b-img-lazy src="/images/product1.jpeg" alt />
              </div>
              <div class="cont text-left">
                <h4>
                  <b>Lorem Ipsum is simply</b>
                </h4>
                <p>Interior Designer</p>
              </div>
              <div class="card-footer">
                <div class="w-50 amt">&#8377; 4823</div>
                <div class="w-50 cart">
                  <div>
                    <shoppingCart></shoppingCart>
                    <span>Buy Now</span>
                  </div>
                </div>
              </div>
    </div>-->
    <!-- end card -->
    <!-- card -->
    <!-- <div class="card">
              <div class="img-div">
                <b-img-lazy src="/images/product2.jpeg" alt="Avatar" />
              </div>
              <div class="cont text-left">
                <h4>
                  <b>Lorem Ipsum is simply</b>
                </h4>
                <p>Interior Designer</p>
              </div>
              <div class="card-footer">
                <div class="w-50 amt">&#8377; 4823</div>
                <div class="w-50 cart">
                  <div>
                    <shoppingCart></shoppingCart>
                    <span>Buy Now</span>
                  </div>
                </div>
              </div>
    </div>-->
    <!-- end card -->
    <!-- card -->
    <!-- <div class="card">
              <div class="img-div">
                <b-img-lazy src="/images/product3.jpeg" alt />
              </div>
              <div class="cont text-left">
                <h4>
                  <b>Lorem Ipsum is simply</b>
                </h4>
                <p>Interior Designer</p>
              </div>
              <div class="card-footer">
                <div class="w-50 amt">&#8377; 4823</div>
                <div class="w-50 cart">
                  <div>
                    <shoppingCart></shoppingCart>
                    <span>Buy Now</span>
                  </div>
                </div>
              </div>
    </div>-->
    <!-- end card -->
    <!--</div>
        </div>
      </div>
    </section>-->
    <!-- end product -->
    <!-- contact -->
    <section>
      <div class="home-contact position-relative text-center">
        <div class="back-img">
          <!-- <b-img-lazy src="/images/cnt_bkg.png" alt class="hidden-xs" /> -->
          <img src="/images/cnt_bkg.webp" alt="contact" class="hidden-xs" />
          <h1>Contact Us</h1>
          <h2>You may reach out to us for all your needs:</h2>
          <div class="py-40">
            <div class="contact-div">
              <div>
                <customerService></customerService>
              </div>
              <div>
                <h3>
                  <b>Customer call center</b>
                </h3>
                <h4>(+91) 7700048012</h4>
              </div>
            </div>
            <div class="contact-div">
              <div>
                <envelope></envelope>
              </div>
              <div>
                <h3>
                  <b>Email</b>
                </h3>
                <a href="mailto:support@docsmart.in">support@docsmart.in</a>
              </div>
            </div>
            <div class="contact-div">
              <div>
                <whatsapp></whatsapp>
              </div>
              <div>
                <h3>
                  <b>Whatsapp</b>
                </h3>
                <h4>+(91) 7208824901</h4>
              </div>
            </div>
          </div>
          <div>
            <button class="btn contact-btn" @click="$router.push('contact-us')">REQUEST A CALL BACK</button>
          </div>
        </div>
      </div>
    </section>
    <!-- end contact -->
    <!-- top button -->

    <!-- top button -->
    <!-- footer section -->
    <Footer />
    <!-- end footer section -->
    <div @click="toTop()" id="scrollTo" :class="showTopButton">
      <rightArrow></rightArrow>
    </div>
    <v-dialog v-if="serviceModal" v-model="serviceModal" width="clamp(650px,40vw,900px)" persistent>
      <service-form-modal :serviceTitle="serviceTitle" @closeServiceForm="closeServiceForm"></service-form-modal>
    </v-dialog>
    <v-dialog v-model="notifyEmailComplete" width="clamp(500px,30vw,800px)" persistent>
      <v-card class="min-height fluid-modal home-service-complete">
        <v-card-text>
          <div class="logo-svg">
            <logo />
          </div>
          <div>
            <h4>Thank You</h4>
            <h6>
              for your Interest.
              We will get back to you!!
            </h6>
          </div>
          <div class="btn-div">
            <v-btn class="btn btn-grn-solid" @click="notifyEmailComplete=false">
              <span>&#8592;</span> Back to home page
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import patientDashboardMixin from "@/methods/patientDashboardMixin";
const Header = () => import("@/components/authorization/header");
const Footer = () => import("@/components/authorization/footer");
const ServiceFormModal = () =>
  import("@/components/authorization/ServiceFormModal");

import { METHODS } from "http";
import { pickSvg } from "@/SVG";
import config from "@/config.js";
export default {
   mixins: [patientDashboardMixin],
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      notifyEmail: "",
      serviceTab: "doctor",
      serviceGroup: false,
      showTopButton: "",
      serviceModal: false,
      notifyEmailComplete: false,
      serviceTitle: ""
    };
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  components: {
   
    Header,
    ServiceFormModal,
    Footer,
    ...pickSvg(
      "doctor",
      "ambulance",
      "prescription",
      "medicalRecord",
      "customerService",
      "blood",
      "patient",
      "chat",
      "seller",
      "stockist",
      "insurance",
      "court",
      "service",
      "likebkg",
      "shoppingCart",
      "envelope",
      "rightArrow",
      "location",
      "whatsapp",
      "ticket",
      "likehrt",
      "logo"
    )
  },
  methods: {
    closeServiceForm() {
      this.serviceModal = false;
    },
    getNotify() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          let inputJson = {
            email: this.notifyEmail
          };

          this.$http
            .post(`${config.NEW_BASE_URL}api/v2/contact-user`, inputJson)
            .then(res => {
              if (res.data.status) {
                this.$validator.reset();
                this.notifyEmailComplete = true;
                this.notifyEmail = "";
              }
            })
            .catch(err => console.log(err));
        }
      });
    },

    openForm(type) {
      this.$validator.reset();
      this.serviceModal = true;
      this.serviceTitle = type;
    },

    handleScroll() {
      this.showTopButton = window.scrollY == 0 ? "scroll-top" : "";
    },
    toTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    },
    showCurrent() {
      setTimeout(function() {
        var elmnt = document.getElementById("docsmartServices");
        elmnt.scrollIntoView({ block: "center", behavior: "smooth" });
      }, 200);
    }
  }
};
</script>
